const TRACKING_LINK_SUBMISSION_RATE_GOOD_THRESHOLD = 80;
const TRACKING_LINK_SUBMISSION_RATE_WARNING_THRESHOLD = 70;

export function getTrackingLinkSubmissionRateColor(rate: number): string {
  if (rate >= TRACKING_LINK_SUBMISSION_RATE_GOOD_THRESHOLD) {
    return "success.main";
  }

  if (rate >= TRACKING_LINK_SUBMISSION_RATE_WARNING_THRESHOLD) {
    return "warning.main";
  }

  return "error.main";
}

export function formatTrackingLinkSubmissionRate(rate: number): string {
  return `${Math.round(rate)}%`;
}
